import Hero from '../components/sections/Hero';
import Accreditation from '../components/sections/Accreditation';
import Disciplines from '../components/sections/Disciplines';
import Learnerships from '../components/sections/Learnerships';
import Stats from '../components/sections/Stats';
import ShortProgrammes from '../components/sections/ShortProgrammes';
import HowToApply from '../components/sections/HowToApply';
import CorporateTraining from '../components/sections/CorporateTraining';
import Faqs from '../components/sections/Faqs';

export default function Home() {
  return (
    <>
      <Hero />
      <Accreditation />
      <Disciplines />
      <Learnerships />
      <Stats />
      <ShortProgrammes />
      <HowToApply />
      <CorporateTraining />
      <Faqs />
    </>
  );
}
